import { useState, useEffect } from 'react';
import { Link } from "react-scroll";
import { Link as Links } from 'react-router-dom';

import Logo from '../../assets/img/logoWhite.png';

import './styles.css';

import Sidebar from '../sidebar';

const Navbar = () =>{
  const [isOpen, setIsOpen] = useState(false);
  const [isStart, setIsStart] = useState(false);
  const handleTrigger = () => {
    setIsOpen(!isOpen)
    setIsStart(true)
  };

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
  }, [])
  const handleScroll = () => {
  setScroll(window.pageYOffset > 600);
  };

  return(
    <>
    {
      isStart && 
      <Sidebar 
      handleTrigger={handleTrigger}
      isOpen={isOpen}
      />
    }
    <nav className={scroll? "navbar navbar-expand-lg navbar-dark fixed-top bg-primary navbarAnimation" :
    "navbar navbar-expand-lg pr-0 pr-lg-auto navbar-dark"}>
      <div className={scroll? "container": "d-flex w-100 justify-content-between"} >
        <Link
        to="home"
        smooth
        className="navbar-brand">
        <img src={Logo}
        alt="..."
        />
        </Link>
        <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={handleTrigger}>
          <span className="navbar-toggler-icon" />
        </button>
        <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item active dropdown">
              <Link
              to="home"
              className="nav-link dropdown-toggle"
              smooth>
                Home
              </Link>
              <div
              className="dropdown-menu"
              aria-labelledby="dropdownMenuButton">
                <Links
                className="dropdown-item"
                to="/home01">
                  Home01
                </Links>
                <Links
                to="/home02"
                className="dropdown-item">
                  Home02
                </Links>
              </div>
            </li>
            <li className="nav-item active">
              <Link
              to="features"
              smooth
              className="nav-link">
                Features
              </Link>
            </li>
            <li className="nav-item active">
              <Link
              to="screenshots"
              smooth
              className="nav-link">
                Screenshots
              </Link>
            </li>
            <li className="nav-item active dropdown">
            <Link
              to="/blog"
              className="nav-link dropdown-toggle"
              smooth>
                Blog
              </Link>
              <div
              className="dropdown-menu"
              aria-labelledby="dropdownMenuButton">
                <Links
                className="dropdown-item"
                to="/Blog01">
                  Blog01
                </Links>
                <Links
                to="/blog02"
                className="dropdown-item">
                  Blog02
                </Links>
                <Links
                to="/blog/details"
                className="dropdown-item">
                  Blog Details
                </Links>
              </div>
            </li>
            <li className="nav-item active">
              <Link
              to="pricing"
              smooth
              className="nav-link">
                Pricing
              </Link>
            </li>
            <li className="nav-item active">
              <Link
              to="contact"
              smooth
              className="nav-link">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </>
  )
};
export default Navbar;